// import '@capacitor-community/http';
import { IonAlert, IonButton, IonButtons, IonCol, IonContent, IonDatetime, IonFooter, IonGrid, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonList, IonLoading, IonModal, IonPopover, IonRow, IonSelect, IonSelectOption, IonTitle, IonToast, IonToggle, IonToolbar, useIonAlert } from '@ionic/react';
import { arrowBack, map } from 'ionicons/icons';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { alteraEquipe, cadastraEquipe, requestService } from '../../../../../Utils/Services';
import { useGooglePlacesSimple } from '../../../../../components/useGooglePlacesSimple';
import { MessageContext } from '../../../../../contexts/MessageContext';
import Endereco from '../Endereco/Endereco';
import './ClientesCad.css';

type MyModalProps = {
  usuario: any;
  inputRef: any;
  closeAction: Function;
  closeActionSimple: Function;
  setLocal: Function;
  setEnderecoLat: Function;
  setEnderecoLng: Function;
  setComplemento: Function;
  setCliente: Function;
}

const ClientesCad: React.FC<MyModalProps> = (props: MyModalProps) => {

  const history = useHistory();

  const { loja } = useContext(MessageContext);

  const [textToast, setTextToast] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [primeiroFoco, setPrimeiroFoco] = useState(false);
  const [pk, setPk] = useState("");
  const [retornoPk, setRetornoPk] = useState("");
  const [retornoEndereco, setRetornoEndereco] = useState("");
  const [retornoEnderecoLat, setRetornoEnderecoLat] = useState("");
  const [retornoEnderecoLng, setRetornoEnderecoLng] = useState("");
  const [retornoComplemento, setRetornoComplemento] = useState("");
  const [retornoNome, setRetornoNome] = useState("");
  const [cpf, setCPF] = useState("");
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [telefone, setTelefone] = useState("");
  const [endereco, setEndereco] = useState("");
  const [enderecoLat, setEnderecoLat] = useState("");
  const [enderecoLng, setEnderecoLng] = useState("");
  const [complemento, setComplemento] = useState("");
  const [dataAniversario, setDataAniversario] = useState("");
  const [dataAniversarioBr, setDataAniversarioBr] = useState("");
  const campoTelefone = useRef<any>(null);
  const [selected, setSelected] = useState<any>("cliente");
  const [selectedColor, setSelectedColor] = useState<any>();
  const [showIncluirUsuario, setShowIncluirUsuario] = useState(false);
  const [alteracao, setAlteracao] = useState(false);
  const [showSucesso, setShowSucesso] = useState(false);
  const [showErro, setShowErro] = useState(false);
  const [lojas, setLojas] = useState<string>(loja);
  const [botaoAtivo, setBotaoAtivo] = useState(true);
  const [showLoading, setShowLoading] = useState(false);
  const [checkedAtivo, setCheckedAtivo] = useState(true);
  const [showModalDataCad, setShowModalDataCad] = useState(false);
  const popover1 = useRef<HTMLIonPopoverElement>(null);

  const [mostartAlerta] = useIonAlert();
  const [localEnderecoSelecionado, setLocalEnderecoSelecionado] = useState<any>("");
  const [listaEnderecos, setListaEnderecos] = useState<any>([]);

  // const [clienteEnderecoLat, setClienteEnderecoLat] = useState('');
  // const [clienteEnderecoLng, setClienteEnderecoLng] = useState('');

  const [showDetalhesEndereco, setShowDetalhesEndereco] = useState(false);

  const inputRefEndereco = useRef<any>(null);

  // Hook Google Places Simple para busca de endereços
  const {
    listaEnderecos: listaEnderecosGoogle,
    buscandoEndereco,
    buscarSugestoes: buscarSugestoesEndereco,
    buscarDetalhes: buscarDetalhesEnderecoHook,
    limparSugestoes
  } = useGooglePlacesSimple({
    onError: (mensagem) => {
      setTextToast(mensagem);
      setShowToast(true);
    },
    onLoading: setShowLoading,
    debounceTime: 2000,
    minChars: 4
  });

  // Flag para evitar busca automática quando preenchemos programaticamente
  const [ignorarProximaMudanca, setIgnorarProximaMudanca] = useState(false);

  useEffect(() => {
    if (props.usuario) {
      console.log("props.usuario", props.usuario);
      setAlteracao(true);
      setPk(props.usuario.pk);
      setCPF(formatCPF(props.usuario.cpf));
      setNome(props.usuario.nome);
      setSelectedColor(props.usuario.color);
      setEnderecoLat(props.usuario.enderecoLat);
      setEnderecoLng(props.usuario.enderecoLng);
      setEndereco(props.usuario.endereco);
      setComplemento(props.usuario.complemento);
      setCheckedAtivo(props.usuario.statusUsuario === "ativo");
      setEmail(props.usuario.email);
      setTelefone(formataTelefone(props.usuario.telefone));

      if (props.usuario.dataAniversario) {
        setDataAniversario(props.usuario.dataAniversario);
        setDataAniversarioBr(new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(
          Date.parse(props.usuario.dataAniversario)
        ));
      }
      setSelected(props.usuario.perfil);
      setLojas(loja);
    }
  }, [props.usuario]);

  useEffect(() => {
    // Define o foco no input quando o componente é montado
    if (props.inputRef.current) {
      props.inputRef.current.focus();
    }
  }, [props.inputRef]);

  function onChangeCPF(e: any) {

    setPrimeiroFoco(true);
    e.persist();
    e.preventDefault();

    if (e.target.value.length > 14) {
      e.target.value = e.target.value.substring(0, 14);
      setCPF(e.target.value.substring(0, 14));
      return;
    }

    let val = e.target.value;
    var cpfval = val.replace(/\D/g, "")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})/, "$1-$2")
      .replace(/(-\d{2})\d+?$/, "$1");
    setCPF(cpfval);

  }

  function onKeyUpTelefone(e: any) {

    e.persist();
    e.preventDefault();



    let val = e.target.value;

    if (val.length > 15) {
      val = val.substring(0, 15);
      setTelefone(val.substring(0, 15));
      return;
    }
    if (val.length < 15) {

      setTelefone(val
        .replace(/\D/g, "")
        .replace(/(\d{2})(\d)/, "($1) $2")
        .replace(/(\d{4})(\d)/, "$1-$2")
        .replace(/(-\d{4})(\d+?)$/, "$1"));
    }
    else {

      setTelefone(val
        .replace(/\D/g, "")
        .replace(/(\d{2})(\d)/, "($1) $2")
        .replace(/(\d{5})(\d)/, "$1-$2")
        .replace(/(-\d{4})(\d+?)$/, "$1"));
    }


  }

  function formatCPF(e: string) {
    let cpfval = e.replace(/\D/g, "")
    cpfval = cpfval.replace(/(\d{3})(\d)/, "$1.$2")
    cpfval = cpfval.replace(/(\d{3})(\d)/, "$1.$2")
    cpfval = cpfval.replace(/(\d{3})(\d{1,2})$/, "$1-$2")
    console.log(cpfval);
    return cpfval;
  }

  const openPopoverCad = (e: any) => {
    popover1.current!.event = e;
    setShowModalDataCad(true);
  };

  function formataTelefone(numero: any) {
    if (numero?.length == 13) {
      let BRNumber = numero.replace("55", "").match(/(\d{2})(\d{5})(\d{4})/);
      BRNumber = "(" + BRNumber[1] + ") " + BRNumber[2] + "-" + BRNumber[3];
      return BRNumber;
    }
    else if (numero?.length == 12) {
      let BRNumber = numero.replace("55", "").match(/(\d{2})(\d{4})(\d{4})/);
      BRNumber = "(" + BRNumber[1] + ") " + BRNumber[2] + "-" + BRNumber[3];
      return BRNumber;
    }
    else { return "" };
  }

  // Função para buscar detalhes do endereço selecionado
  const buscarDetalhesEndereco = async (placeId: string, enderecoFormatado: string) => {
    try {
      const detalhes = await buscarDetalhesEnderecoHook(placeId, enderecoFormatado);

      // Preencher campos automaticamente
      setIgnorarProximaMudanca(true);
      setEndereco(detalhes.endereco);
      setEnderecoLat(detalhes.latitude.toString());
      setEnderecoLng(detalhes.longitude.toString());

      // Limpar sugestões
      limparSugestoes();

      setTextToast("Endereço validado com sucesso.");
      setShowToast(true);

    } catch (error) {
      console.error("Erro ao buscar detalhes:", error);
    }
  };

  // Handler para seleção de item da lista de sugestões
  const handleSelectItemEndereco = (item: any) => {
    console.log("Item selecionado:", item);
    buscarDetalhesEndereco(item.placeId, item.descricao);
  };

  function cadastrar() {

    console.log("aaaa", selected);

    if (nome.length == 0) {
      setTextToast("Campo Nome é obrigatório.");
      setShowErro(true);
    }
    else {
      if (telefone.length != 15 && telefone.length != 14) {
        setTextToast("Campo Telefone é obrigatório.");
        setShowErro(true);
      }
      else {
        setShowIncluirUsuario(true);
      }
    }
  }

  function readListaEnderecos() {
    return listaEnderecos.map((value: any, index: any) => (
      <IonItem
        key={"endereco" + value.place_id}
        button
        onClick={() => setLocalEnderecoSelecionado(value.formatted_address)}
        color={localEnderecoSelecionado === value.formatted_address ? 'tertiary' : ''}
      >
        <IonLabel>{value.formatted_address}</IonLabel>
      </IonItem>
    ));
  }

  async function closeModalEndereco(enderecoSelecionado: any, latitudeSelecionado: any, enderecoLngSelecionado: any) {
    console.log("enderecoSelecionado", enderecoSelecionado);
    console.log("latitudeSelecionado", latitudeSelecionado);
    console.log("enderecoLngSelecionado", enderecoLngSelecionado);

    setEndereco(enderecoSelecionado);
    setEnderecoLat(latitudeSelecionado);
    setEnderecoLng(enderecoLngSelecionado);

    setShowDetalhesEndereco(false);
  }

  async function closeModalSimpleEndereco() {
    setShowDetalhesEndereco(false);
  }

  return (
    <>
      <IonHeader>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonIcon slot="icon-only" icon={arrowBack} onClick={() => props.closeActionSimple()} />
          </IonButtons>
          <IonTitle>Cadastro de clientes</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonGrid>
          <IonRow>
            <IonCol>
              <IonList>

                <IonItem lines="none">
                  <IonLabel position="stacked">Nome*</IonLabel>
                  <IonInput placeholder="Digite o nome completo" value={nome} ref={(ref) => props.inputRef.current = ref} autoCorrect='true' autoCapitalize='true' required onIonInput={(e: any) => setNome(e.target.value)}></IonInput>
                </IonItem>


                {/* <IonItem lines="none">
                  <IonLabel>Interno</IonLabel>
                  <IonToggle slot='end' checked={checkedInterno} onIonChange={e => {
                    setCheckedInterno(e.detail.checked);
                  }} />
                </IonItem> */}

                <IonItem lines="none">
                  <IonLabel position="stacked">Telefone*</IonLabel>
                  <IonInput disabled={alteracao} ref={(ref) => campoTelefone.current = ref} type="tel" maxlength={15} placeholder="(__) _____-____" required value={telefone} onKeyUp={onKeyUpTelefone} />
                </IonItem>

                <IonItem lines="none">
                  <IonLabel position="stacked">CPF</IonLabel>
                  <IonInput disabled={alteracao} type="tel" maxlength={14} placeholder="___.___.___-__" required value={cpf} onKeyUp={onChangeCPF} />
                </IonItem>

                <IonItem lines="none">
                  <IonLabel position="stacked">Endereço</IonLabel>
                  <IonInput
                    value={endereco}
                    autoCorrect='true'
                    autoCapitalize='true'
                    placeholder="Avenida Paulista, 111, São Paulo"
                    onIonInput={(e: any) => {
                      const valor = e.target.value || "";
                      setEndereco(valor);

                      // Se flag estiver ativa, ignorar busca (foi preenchimento automático)
                      if (ignorarProximaMudanca) {
                        setIgnorarProximaMudanca(false);
                        return;
                      }

                      // Buscar sugestões automaticamente
                      buscarSugestoesEndereco(valor);
                    }}
                    onKeyDown={(e: any) => {
                      // Enter força busca imediata
                      if (e.key === "Enter") {
                        e.preventDefault();
                        const valor = endereco || '';
                        if (valor.trim().length >= 4) {
                          buscarSugestoesEndereco(valor, true);
                        } else {
                          setTextToast('Digite no mínimo 4 caracteres para buscar.');
                          setShowToast(true);
                        }
                      }
                    }}
                  ></IonInput>
                  <IonIcon slot="end" size="large" color="primary" icon={map} onClick={() => { setShowDetalhesEndereco(true); }} />
                </IonItem>

                {/* Lista de sugestões do Google Places */}
                {listaEnderecosGoogle?.length > 0 && (
                  <IonItem lines="none">
                    <div style={{ width: '100%', position: 'relative', zIndex: 1000 }}>
                      {listaEnderecosGoogle.map((item: any, index: any) => (
                        <div
                          key={"sugestao" + index}
                          style={{
                            padding: '10px',
                            borderBottom: '1px solid #eee',
                            cursor: 'pointer',
                            backgroundColor: '#f9f9f9',
                            marginBottom: '2px'
                          }}
                          onClick={() => handleSelectItemEndereco(item)}
                        >
                          <strong>{item.descricaoPrincipal}</strong>
                          {item.descricaoSecundaria && <div style={{ fontSize: '0.9em', color: '#666' }}>{item.descricaoSecundaria}</div>}
                        </div>
                      ))}
                    </div>
                  </IonItem>
                )}

                {/* <IonItem lines="none">
                  <IonButton slot="end" style={{ textAlign: 'right' }} onClick={() => { setShowDetalhesEndereco(true); }}>Mapa</IonButton>
                </IonItem> */}
                {/* <IonItem lines="none">
                  <IonLabel position="stacked">EnderecoLat</IonLabel>
                  <IonInput value={enderecoLat} autoCorrect='true' autoCapitalize='true' placeholder="Digite a enderecoLat" onIonInput={(e: any) => setEnderecoLat(e.target.value)}></IonInput>
                </IonItem>

                <IonItem lines="none">
                  <IonLabel position="stacked">EnderecoLng</IonLabel>
                  <IonSelect value={enderecoLng} placeholder="Selecione o EnderecoLng" onIonChange={(e) => setEnderecoLng(e.detail.value)}>
                    {enderecoLngs.map((enderecoLng) => (
                      <IonSelectOption key={enderecoLng.sigla} value={enderecoLng.sigla}>
                        {enderecoLng.sigla}
                      </IonSelectOption>
                    ))}
                  </IonSelect>
                </IonItem> */}


                <IonItem lines="none">
                  <IonLabel position="stacked">Complemento</IonLabel>
                  <IonInput value={complemento} autoCorrect='true' autoCapitalize='true' placeholder="Apartamento, bloco, etc." onIonInput={(e: any) => setComplemento(e.target.value)}></IonInput>
                </IonItem>



                <IonItem lines="none">
                  <IonLabel position="stacked">E-mail</IonLabel>
                  <IonInput value={email} type='email' autoCorrect='true' placeholder="Digite o e-mail" onIonInput={(e: any) => setEmail(e.target.value)}></IonInput>
                </IonItem>

                <IonItem lines="none">
                  <IonLabel position="stacked">Aniversário</IonLabel>
                  <IonInput value={dataAniversarioBr} placeholder="Selecione" onClick={e => { openPopoverCad(e); }}></IonInput>
                </IonItem>

                <IonItem lines="none" hidden={!alteracao} >
                  <IonLabel>Ativo</IonLabel>
                  <IonToggle slot='end' checked={checkedAtivo} onIonChange={e => {
                    setCheckedAtivo(e.detail.checked);
                  }} />
                </IonItem>

                <IonItem disabled={alteracao} lines="none" hidden={(window.localStorage.getItem("lojas") && JSON.parse(window.localStorage.getItem("lojas") || "").length > 1) ? false : true}>
                  <IonLabel position='stacked'>Lojas</IonLabel>
                </IonItem>
                <IonItem disabled={alteracao} lines="none" hidden={(window.localStorage.getItem("lojas") && JSON.parse(window.localStorage.getItem("lojas") || "").length > 1) ? false : true}>
                  <IonLabel position='stacked'></IonLabel>
                  <IonSelect name='Lojas' placeholder='Selecione' title='Lojas' value={lojas} cancelText="Cancel" okText="Ok" onIonChange={e => { setLojas(e.detail.value); }} slot="end">
                    {JSON.parse(window.localStorage.getItem("lojas") || "[]").map((valor: any) => (
                      <IonSelectOption value={valor.empresaLojaId}>{valor.empresaLojaNome}</IonSelectOption>
                    ))}
                  </IonSelect>
                </IonItem>

              </IonList>
            </IonCol>
          </IonRow>
        </IonGrid>

        <IonAlert isOpen={showIncluirUsuario}
          onDidDismiss={() => setShowIncluirUsuario(false)}
          header={'Cadastro de usuário'}
          message={'Você <strong>confirma</strong> inclusão?'}
          buttons={[
            {
              text: 'Cancelar',
              role: 'cancel',
            },
            {
              text: 'Confirmar',
              cssClass: 'primary',
              handler: () => {

                let dataNiver = "";

                console.log("dataAniversario", dataAniversario);
                if (dataAniversario) {
                  dataNiver = dataAniversario;
                }
                const objectRequest = {
                  cpf: cpf.replace("-", "").replace(".", "").replace(".", ""),
                  pk: pk,
                  nome: nome,
                  email: email,
                  endereco: endereco,
                  enderecoLat: enderecoLat,
                  enderecoLng: enderecoLng,
                  complemento: complemento,
                  color: selectedColor,
                  telefone: "55" + telefone.replace("(", "").replace(")", "").replace(" ", "").replace("-", ""),
                  perfil: selected,
                  interno: false,
                  statusUsuario: checkedAtivo ? "ativo" : "inativo",
                  empresaMarca: localStorage.getItem("empresaMarca") || "",
                  dataAniversario: dataNiver,
                  lojas: JSON.parse(window.localStorage.getItem("lojas") || "[]").filter((value: any) => {
                    return lojas.includes(value.empresaLojaId);
                  })
                }


                if (!alteracao) {

                  requestService(cadastraEquipe.url, {
                    method: cadastraEquipe.method,
                    headers: [["token", localStorage.getItem("token") || ""]],
                    credentials: 'include',
                    body: JSON.stringify(objectRequest)
                  },
                    history,
                    (response: any) => {
                      window.localStorage.setItem("enderecoLngDefaultCliente", enderecoLng);
                      window.localStorage.setItem("latitudeDefaultCliente", enderecoLat);
                      setRetornoPk(response.usuario.pk);
                      setRetornoEndereco(response.usuario.endereco);
                      setRetornoEnderecoLat(response.usuario.enderecoLat);
                      setRetornoEnderecoLng(response.usuario.enderecoLng);
                      setRetornoComplemento(response.usuario.complemento);
                      setRetornoNome(response.usuario.nome);

                      setNome("");
                      setCPF("");
                      setSelectedColor("");
                      setEndereco("");
                      setEnderecoLat("");
                      setEnderecoLng("");
                      // setEnderecoLat("");
                      // setEnderecoLng("");
                      setComplemento("");
                      setTelefone("");
                      setCheckedAtivo(true);
                      setEmail("");
                      setDataAniversario("");
                      setSelected("usuario");
                      setTextToast("Cadastro realizado com sucesso.");
                      setShowSucesso(true);
                      if (props.setLocal) props.setLocal(response.usuario.endereco);
                      if (props.setCliente) props.setCliente(response.usuario.pk);
                    },
                    (error: any) => {
                      setTextToast(error.message);
                      setShowErro(true);
                      if (error.data) {
                        console.log("entrou varios endereços");
                        if (Array.isArray(error.data) && error.data.length > 0) {
                          setListaEnderecos(error.data);
                        }
                      }
                    });
                }
                else {
                  requestService(alteraEquipe.url, {
                    method: alteraEquipe.method,
                    headers: [["token", localStorage.getItem("token") || ""]],
                    credentials: 'include',
                    body: JSON.stringify(objectRequest)
                  },
                    history,
                    (response: any) => {
                      window.localStorage.setItem("enderecoLngDefaultCliente", enderecoLng);
                      window.localStorage.setItem("latitudeDefaultCliente", enderecoLat);

                      setNome("");
                      setCPF("");
                      setSelectedColor("");
                      setEndereco("");
                      setEnderecoLat("");
                      setEnderecoLng("");
                      // setEnderecoLat("");
                      // setEnderecoLng("");
                      setComplemento("");
                      setTelefone("");
                      setCheckedAtivo(true);
                      setEmail("");
                      setDataAniversario("");
                      setSelected("usuario");
                      setTextToast("Alteração realizada com sucesso.");
                      setShowSucesso(true);
                    },
                    (error: any) => {
                      setTextToast(error.message);
                      setShowErro(true);
                      if (error.data) {
                        console.log("entrou varios endereços");
                        if (Array.isArray(error.data) && error.data.length > 0) {
                          setListaEnderecos(error.data);
                        }
                      }
                    });
                }
              }
            }
          ]}
        />

        <IonModal isOpen={(Array.isArray(listaEnderecos) && listaEnderecos.length > 0)} onDidDismiss={() => { setListaEnderecos([]); }}>
          <IonHeader className="ion-no-border">
            <IonToolbar>
              <IonTitle>Selecione um endereço</IonTitle>
              <IonButtons slot="start" onClick={() => setListaEnderecos([])}>
                <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            <IonList>
              {readListaEnderecos()}
            </IonList>
          </IonContent>
          <IonFooter>
            <IonButton expand="block" color="primary" onClick={(e) => {

              mostartAlerta({
                backdropDismiss: false,
                header: 'Número',
                message: 'Adicione Número',
                inputs: [
                  {
                    name: 'mensagem',
                    type: 'textarea',
                    id: 'name2-id',
                    placeholder: 'Digite aqui o número',
                  }],
                buttons: ['Cancel', {
                  text: 'OK', handler: (d) => {
                    setEndereco(localEnderecoSelecionado + ", " + d.mensagem);
                  }
                }],
                onDidDismiss: (e) => { console.log('did dismiss'); }
              })

              setListaEnderecos([]);
            }}>Avançar</IonButton>
          </IonFooter>
        </IonModal>

        <IonModal className="fullscreen-modal"
          onDidPresent={() => {
            if (inputRefEndereco.current) {
              inputRefEndereco.current.setFocus();
            }
          }} isOpen={showDetalhesEndereco} onDidDismiss={() => { setShowDetalhesEndereco(false); }}>
          <Endereco endereco={endereco} inputRef={inputRefEndereco} closeAction={closeModalEndereco} closeActionSimple={closeModalSimpleEndereco}></Endereco>
        </IonModal>


        <IonPopover ref={popover1}
          isOpen={showModalDataCad}
          onDidDismiss={() => setShowModalDataCad(false)} >
          <IonContent>
            <IonDatetime

              presentation='date'

              onIonChange={e => {

                if (e.detail.value) {
                  let data = e.detail.value.toString().substring(0, 10);
                  const dataFormatada = new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(
                    Date.parse(data)
                  );
                  setDataAniversarioBr(dataFormatada);
                  setDataAniversario(data);
                }
              }}></IonDatetime>
          </IonContent>
        </IonPopover >


        <IonAlert isOpen={showSucesso}
          onDidDismiss={() => { setShowSucesso(false); }}
          header={'Sucesso'}
          message={textToast}
          backdropDismiss={false}
          buttons={[
            {
              text: 'OK',
              handler: () => { setShowSucesso(false); props.closeAction(retornoPk, retornoEndereco, retornoEnderecoLat, retornoEnderecoLng, retornoComplemento, retornoNome); }
            }
          ]} />

        <IonAlert isOpen={showErro}
          onDidDismiss={() => setShowErro(false)}
          header={'Erro'}
          message={textToast}
          buttons={['OK']}
        />

        <IonToast
          isOpen={showToast}
          position="middle" //top, bottom, middle
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />


        <IonLoading
          cssClass='my-custoDm-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          message={'Incluindo...'}

        />

      </IonContent>
      <IonFooter className="ion-no-border">
        <IonToolbar>
          <IonButton disabled={!botaoAtivo} onClick={() => cadastrar()} expand="block" type="submit">SALVAR</IonButton>
        </IonToolbar>
      </IonFooter>
    </>
  );
};

export default ({ usuario, inputRef, closeAction, closeActionSimple, setLocal, setEnderecoLat, setEnderecoLng, setComplemento, setCliente }: { usuario: any, inputRef: any, closeAction: Function, closeActionSimple: Function, setLocal: Function, setEnderecoLat: Function, setEnderecoLng: Function, setComplemento: Function, setCliente: Function }) => (
  <ClientesCad usuario={usuario} inputRef={inputRef} closeAction={closeAction} closeActionSimple={closeActionSimple} setLocal={setLocal} setEnderecoLat={setEnderecoLat} setEnderecoLng={setEnderecoLng} setComplemento={setComplemento} setCliente={setCliente} >
  </ClientesCad>
)
